import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import ConfModal from "@/components/ConfModal.vue";
import { Modal } from "flowbite-vue";
import {ref, onMounted} from 'vue';
import { initFlowbite } from "flowbite";


export default /*#__PURE__*/_defineComponent({
  __name: 'taccuinoLock',
  setup(__props, { expose: __expose }) {

const indexgl = ref(0);
const showConfirm = ref(false);
let resolvePromise: (value: PromiseLike<boolean> | boolean) => void;

onMounted(() => {
  initFlowbite();
});

function openModal(message: string, index: number): Promise<boolean> {
    indexgl.value = index;
    showConfirm.value = true;
    return new Promise((resolve) => {
    resolvePromise = resolve;
    });
}

function close() {
    showConfirm.value = false
    if (!resolvePromise) return;
       resolvePromise(true);
}

__expose({ openModal });

return (_ctx: any,_cache: any) => {
  const _component_ConfModalHead = _resolveComponent("ConfModalHead")!

  return (showConfirm.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        size: "2xl",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (close()))
      }, {
        header: _withCtx(() => [
          _createVNode(_component_ConfModalHead)
        ]),
        body: _withCtx(() => [
          _createVNode(ConfModal, {
            table: 'tbl_taccuinos',
            idtype: 'id_taccuino',
            "id-conf": 'id_livello_confidenzialita',
            index: indexgl.value,
            onCloseModal: _cache[0] || (_cache[0] = ($event: any) => (close()))
          }, null, 8, ["index"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})